<tr [formGroup]="form">
  <td>
    <ng-container *ngIf="!editMode">{{name.value}}</ng-container>
    <div *ngIf="editMode">
      <input type="text" formControlName="name"/>
      <div *ngIf="name.invalid && (name.dirty || name.touched)">
        <div class="input-error" *ngIf="name.errors.required">Name wird benötigt.</div>
        <div class="input-error" *ngIf="name.errors.repeatedName">Name kann sich nicht wiederholen.</div>
      </div>
    </div>
  </td>
  <td>
    <ng-container *ngIf="!editMode">{{cooperationPartner.value}}</ng-container>
    <div *ngIf="editMode">
      <input type="text" formControlName="cooperationPartner"/>
      <div *ngIf="cooperationPartner.invalid && (cooperationPartner.dirty || cooperationPartner.touched)">
        <div class="input-error" *ngIf="cooperationPartner.errors.required">Angabe wird benötigt.</div>
      </div>
    </div>
  </td>
  <td>
    <ng-container *ngIf="!editMode">{{cooperationContent.value}}</ng-container>
    <div *ngIf="editMode">
      <textarea *ngIf="editMode" formControlName="cooperationContent"></textarea>
      <div *ngIf="cooperationContent.invalid && (cooperationContent.dirty || cooperationContent.touched)">
        <div class="input-error" *ngIf="cooperationContent.errors.required">Angabe wird benötigt.</div>
      </div>
    </div>
  </td>
  <td *ngIf="editMode">
    <lsz-dataset-options [form]="form" (save)="entrySaved.emit()" (delete)="entryDeleted.emit()"></lsz-dataset-options>
  </td>
  <td>
    <lsz-last-edit [form]="form"></lsz-last-edit>
  </td>
</tr>
